// Story 96 — risk R3, the highest of the Jupiter slice.
//
// The planner event dialog used to dispatch EVERYTHING by numeric tab index: the save
// (`switch (selectedTab) case 0..3`, with cases 2 and 3 already dead), the pin load
// (`selectedTab === 1`), the dirty-tab guard and even the dialog size. Inserting the new "Job
// Settings" tab in FIRST position shifts every one of those indices, which is exactly how a story
// like this silently breaks the Part priority or the date pin (S81/S82/S83).
//
// So the index stops being an identity and becomes what it really is: a position in a list. This
// module is the single place that knows the order; everything else asks for the tab KEY and switches
// on it. Adding, removing or reordering a tab from now on only touches EVENT_DIALOG_TABS.

export const EVENT_DIALOG_TAB_KEYS = {
  // First and selected by default (RN36/CA6).
  JOB_SETTINGS: 'jobSettings',
  PART_SETTINGS: 'partSettings',
  PIN_SETTING: 'pinSetting'
}

/** The tabs of the dialog, in the order they are shown. Labels are i18n keys. */
export const EVENT_DIALOG_TABS = [
  { key: EVENT_DIALOG_TAB_KEYS.JOB_SETTINGS, label: 'Job Settings' },
  { key: EVENT_DIALOG_TAB_KEYS.PART_SETTINGS, label: 'Part Settings' },
  { key: EVENT_DIALOG_TAB_KEYS.PIN_SETTING, label: 'Pin Setting' }
]

/** Index the dialog opens on: the first tab (RN36). */
export const DEFAULT_EVENT_DIALOG_TAB_INDEX = 0

/**
 * The key of the tab shown at a given position, for the one boundary that is unavoidably positional
 * (SmartNavigator's `selected`). Converting at the boundary is what keeps every switch name-based.
 *
 * @param {number} index Position in EVENT_DIALOG_TABS
 * @returns {string} Tab key, or '' when the position does not exist
 */
export const getEventDialogTabKey = (index) => EVENT_DIALOG_TABS[index]?.key ?? ''

/**
 * The position of a tab, for the same boundary in the opposite direction.
 *
 * @param {string} key Tab key
 * @returns {number} Position, or the default tab's position when the key is unknown
 */
export const getEventDialogTabIndex = (key) => {
  const index = EVENT_DIALOG_TABS.findIndex((tab) => tab.key === key)
  return index === -1 ? DEFAULT_EVENT_DIALOG_TAB_INDEX : index
}
